import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  deleteEtiquetaFamilia,
  getEtiquetasFamilia,
  insertEtiquetaFamilia,
  updateEtiquetaFamilia,
} from 'services/personalizacion'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_ETIQUETAS_FAMILIA() {
  try {
    const etiquetasFamiliaData = yield call(getEtiquetasFamilia)
    if (etiquetasFamiliaData.ok) {
      yield put({
        type: actions.ETIQUETA_FAMILIA_LOAD_SUCCEEDED,
        payload: etiquetasFamiliaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.ETIQUETA_FAMILIA_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.ETIQUETA_FAMILIA_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_ETIQUETA_FAMILIA(action) {
  try {
    const etiquetasFamiliaData = yield call(insertEtiquetaFamilia, action.payload)
    if (etiquetasFamiliaData.ok) {
      putMessage(messageType.SUCCESS, 'Creada correctamente')
      yield put({
        type: actions.ETIQUETA_FAMILIA_INSERT_SUCCEEDED,
        payload: etiquetasFamiliaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.ETIQUETA_FAMILIA_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.ETIQUETA_FAMILIA_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_ETIQUETA_FAMILIA(action) {
  try {
    const etiquetasFamiliaData = yield call(updateEtiquetaFamilia, action.payload)
    if (etiquetasFamiliaData.ok) {
      yield put({
        type: actions.ETIQUETA_FAMILIA_UPDATE_SUCCEEDED,
        payload: etiquetasFamiliaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.ETIQUETA_FAMILIA_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.ETIQUETA_FAMILIA_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_ETIQUETA_FAMILIA(action) {
  try {
    const etiquetasFamiliaData = yield call(deleteEtiquetaFamilia, action.payload)
    if (etiquetasFamiliaData.ok) {
      yield put({
        type: actions.ETIQUETA_FAMILIA_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.ETIQUETA_FAMILIA_DELETE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.ETIQUETA_FAMILIA_DELETE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.ETIQUETA_FAMILIA_LOAD_REQUESTED, GET_ETIQUETAS_FAMILIA),
    takeEvery(actions.ETIQUETA_FAMILIA_INSERT_REQUESTED, INSERT_ETIQUETA_FAMILIA),
    takeEvery(actions.ETIQUETA_FAMILIA_UPDATE_REQUESTED, UPDATE_ETIQUETA_FAMILIA),
    takeEvery(actions.ETIQUETA_FAMILIA_DELETE_REQUESTED, DELETE_ETIQUETA_FAMILIA),
  ])
}
